import { EAuthenticateByTokenStatus, ERegisterOrAuthByTokenStatus, ERegisterOrAuthStatus, ESendValidationCodeStatus, ECheckPhoneStatus } from '../../types/phoneAuth';
export var defaultState = {
  registerOrAuth: {
    accounts: [],
    temporaryToken: '',
    status: ERegisterOrAuthStatus.Initial
  },
  authenticateByToken: {
    status: EAuthenticateByTokenStatus.Initial
  },
  registerOrAuthByToken: {
    status: ERegisterOrAuthByTokenStatus.Initial
  },
  sendValidationCode: {
    secondsToRetry: null,
    status: ESendValidationCodeStatus.Initial
  },
  checkPhone: {
    status: ECheckPhoneStatus.Initial,
    error: ''
  },
  phone: ''
};